import { makeTab } from '@sravni/ugc/lib/specialOffers/helpers';
import { EDUCATION_OFFERS, LEARNING_TYPES } from '@sravni/ugc/lib/specialOffers/lists';
import type { LearningTypes, OFFERS_TYPE, VITRINS_OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import type { ISpecialOffersContext } from '../contexts/OffersPageQueryContext';
import { DEFAULT_OFFERS_PAGE_CONTEXT } from '../contexts/OffersPageQueryContext';
import type { IVerticalListContext } from '../contexts/VerticalListQueryContext';
import { DEFAULT_VERTICAL_LIST_PAGE_CONTEXT } from '../contexts/VerticalListQueryContext';
import type { TOffersPageQuery, TVerticalListPageQuery } from '../types/query';

export const convertOffersPageQuery = (query: TOffersPageQuery): ISpecialOffersContext => ({
  isNeedBVersion: query.isBVersion === 'true',
  iframeId: query.iframeId || '',
  abName: query.abName || '',
  isPopup: query.isPopup === 'true',

  isWithButtons: query.isWithButtons === 'true' ?? DEFAULT_OFFERS_PAGE_CONTEXT.isWithButtons,
  isVerticalOnMobile: query.isVerticalOnMobile === 'true' ?? DEFAULT_OFFERS_PAGE_CONTEXT.isVerticalOnMobile,

  bonusFilter: typeof query.bonusFilter === 'string' ? [query.bonusFilter] : query.bonusFilter,
  organizationId: typeof query.organizationId === 'string' ? [query.organizationId] : query.organizationId,

  firstTab: makeTab<OFFERS_TYPE>(query.firstTab as OFFERS_TYPE, query.subproduct as LearningTypes),
});

export const convertVerticalListPageQuery = (query: TVerticalListPageQuery): Omit<IVerticalListContext, 'isMobile'> => {
  const programmingTab =
    query.tabType === EDUCATION_OFFERS.learning &&
    !query.subproduct &&
    makeTab<VITRINS_OFFERS_TYPE>(query.tabType as VITRINS_OFFERS_TYPE, LEARNING_TYPES.typeProgramming);

  return {
    tab:
      programmingTab ||
      makeTab<VITRINS_OFFERS_TYPE>(query.tabType as VITRINS_OFFERS_TYPE, query.subproduct as LearningTypes),
    ...(query.organizationId && { organizationId: query.organizationId }),
    limit: Number(query.limit) || DEFAULT_VERTICAL_LIST_PAGE_CONTEXT.limit,
    skip: Number(query.skip) || DEFAULT_VERTICAL_LIST_PAGE_CONTEXT.skip,
    iframeId: query.iframeId,
  };
};
